var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkPrimaryIcon = function SvgLinkPrimaryIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F55F00",
    d: "M17.192 23.295a1 1 0 0 1 0 1.414l-1.242 1.25a7.004 7.004 0 1 1-9.903-9.909l3.015-3.015a7 7 0 0 1 9.602-.285 1.002 1.002 0 1 1-1.33 1.5 5 5 0 0 0-6.857.204l-3.015 3.011a5.001 5.001 0 1 0 7.073 7.073l1.242-1.243a1 1 0 0 1 1.415 0m8.76-17.25a7.01 7.01 0 0 0-9.902 0l-1.243 1.244a1 1 0 0 0 1.415 1.414l1.243-1.243a5.001 5.001 0 0 1 7.072 7.073l-3.015 3.017a5 5 0 0 1-6.856.2 1.003 1.003 0 0 0-1.33 1.5 7 7 0 0 0 9.601-.282l3.015-3.015a7.01 7.01 0 0 0 0-9.906z"
  })));
};
export default SvgLinkPrimaryIcon;